import ResetPassword from '@features/games/profile/reset-password/reset-password';
export default ResetPassword;
